import { DateTime } from "luxon"

export interface DateTimeData {
    date: string
    time: string
}

// Because the ODataApi returns the value in the format 00:00:00.0000000 we need to parse it
export const parseOdataTimeValue = (value: string): string => {
    if (value === "") {
        return value
    }
    const parts = value.split(":")
    return `${parts[0]}:${parts[1]}`
}

export const parseUserInputForUsTime = (newValue: string): string => {
    const a = DateTime.fromFormat(newValue, "h:mm a")
    return a.toFormat("HH:mm")
}

export const parseUserInputToUsTime = (newValue: string): string => {
    const a = DateTime.fromFormat(newValue, "HH:mm")
    return a.toFormat("h:mm a")
}

export const parseOdataDateValue = (value: string): string | undefined => {
    //datapi gives us value in format yyyy-MM-dd
    const parsedDate = DateTime.fromFormat(value, "yyyy-MM-dd")
    if (!parsedDate.isValid) {
        return undefined
    }
    return parsedDate.toJSDate().toISOString()
}

export const formatDateTimeStringFromISO = (
    dateString: string,
    userFormattingSettings?: UserMenu.UserFormattingSettings,
): string | undefined => {
    if (!dateString) {
        return ""
    }
    const date = DateTime.fromISO(dateString)
    if (!date.isValid) {
        return undefined
    }
    return date.toFormat(
        `${userFormattingSettings?.shortDatePattern || "dd/MM/yyyy"} ${
            userFormattingSettings?.shortTimeFormat || "HH:mm"
        }`,
    )
}

export const convertStringToDateTime = (
    dateString: string,
): DateTime | undefined => {
    if (!dateString) {
        return undefined
    }
    const date = DateTime.fromISO(dateString)
    if (!date.isValid) {
        return undefined
    }
    return date
}
